import { buildUpdateAddressInputSchema } from '../address/update-input.js';
import { customerAddressTypeIdSchema } from './create-input.js';
export const updateCustomerAddressInputSchema = buildUpdateAddressInputSchema(customerAddressTypeIdSchema, { requireFullAddress: true });
//# sourceMappingURL=update-input.js.map